module.exports = __webpack_public_path__ + "img/s81_thumb.f0f97c2d.jpg";